import React from 'react';
import Icon from 'components/icon/icon'
import { 
    paragraphToLines,
    stripHtml
} from 'utils'

import moment from 'moment'

const Note = props => {
    const {
        changeNote,
        deleteNote,
        note,
        isCurrent,
        canDelete,
        meeting
    } = props

    let firstLine = null
    let secondLine = null

    if(!meeting){
        if(note.name){
            firstLine = note.name
        }

        if(note.start_date){
            secondLine = moment(note.start_date).format('MMMM Do')

            if(note.location){
                secondLine += ' • '+note.location
            }
        }else if(note.location){
            secondLine = note.location
        }

        if(!firstLine || !secondLine){
            const allLines = paragraphToLines(note.text)

            allLines && allLines.some(line => {
                if(line){
                    if(!firstLine){
                        firstLine = stripHtml(line)
                    }else if(!secondLine){
                        secondLine = stripHtml(line)

                        return true
                    }
                }
            })
        }
    }else{
        firstLine = moment(meeting.start_date).format('MMMM Do')
        secondLine = meeting.location ? meeting.location : '(No location)'
    }

    return (
        <li className={ isCurrent ? 'active' : null }>
            <button onClick={_ => { changeNote(note.id) }}>
                <h3>
                    { firstLine ? firstLine : 'New note' }
                </h3>
                <span dangerouslySetInnerHTML={{ __html: secondLine ? secondLine : 'No additional text' }} />
            </button>
            { canDelete && 
                <div 
                    onClick={_ => {
                        deleteNote(note)
                    }} 
                    className="delete-note"
                >
                   <Icon name="fe-trash-2" />
                </div>
            }
        </li>  
    );       
};

export default Note